module.exports = __webpack_public_path__ + "static/media/tickets.191417e6.svg";